@if (translations) {
  @for (market of markets; track market) {
    <div (click)="selectMarket(market)" class="market" [ngClass]="selectedMarket.marketname === market.marketname ? 'selected' : 'not-selected'">
      @if (translations) {
        <span>{{ getMarketName(market) }}</span>
      }
    </div>
  }
}

<div id="slider" [ngStyle]="{'left': getMarketSliderLeftPosition() }"></div>